import { createReducer } from 'Helpers/redux'
import {
  ORDER_PAYOUT,
  GET_TRANSACTIONS,
  GET_TRANSACTIONS_DETAILS,
} from '../actions/transactionsActions'
import { ADD_TRANSFERWISE_RECIPIENT } from '../actions/transferwiseActions'

const initialState = {
  transactions: [],
  recipient: null,
  balance: 0,
  totalTransactions: 0,
  transactionsPayment: 0,
  transactionsPaidOut: 0,
}

const handlers = {
  [ORDER_PAYOUT.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    // transactions: [payload, ...prevState.transactions],
    // balance: 0,
  }),
  [GET_TRANSACTIONS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    transactions:
      payload.meta.pageNumber === 1
        ? payload.data
        : [...prevState.transactions, ...payload.data],
    totalTransactions: payload.meta.itemCount,
    // recipient: payload.recipient,
    // totalTransactions: payload.totalTransactions,
    // transactionsPayment: payload.transactionsPayment,
    // transactionsPaidOut: payload.transactionsPaidOut,
    // balance: payload.balance,
    // hasAwaiting: payload.hasAwaiting,
  }),
  [GET_TRANSACTIONS_DETAILS.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    hasAwaiting: payload.hasAwaitingPayout,
    transactionsPayment: payload.earnedTotalAmount,
    transactionsPaidOut: payload.payoutTotalAmount,
    recipient: payload.isRecipient,
    // recipient: payload.recipient,
    // totalTransactions: payload.totalTransactions,
    // transactionsPayment: payload.transactionsPayment,
    // transactionsPaidOut: payload.transactionsPaidOut,
    // balance: payload.balance,
    // hasAwaiting: payload.hasAwaiting,
  }),
  [ADD_TRANSFERWISE_RECIPIENT.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    recipient: payload,
  }),
}

export default createReducer(initialState, handlers)
